export enum FonctionLogicielle {
  Absences = 1,
  ConceptionModeles = 4,
  Entites = 7,
  Entreprises = 8,
  Evaluations = 10,
  Facturation = 11,
  Formateurs = 12,
  FormationsCatalogue = 13,
  Inscriptions = 15,
  MesParametres = 18,
  MonAgenda = 20,
  MonCompte = 21,
  ParametresGeneraux = 23,
  ParametresEntite = 24,
  Personnes = 25,
  PlanificationSessions = 26,
  PlanningFormateurs = 27,
  ProfilsDroits = 28,
  Publipostage = 29,
  Taches = 30,
  Paiements = 33,
  Ressources = 34,
  SupportAxess = 37,
  Articles = 38,
  Personnels = 40,
  GestionTarifs = 41,
  FinancementInscriptions = 42,
  Demo = 43,
  Modules = 44,
  Oscar = 45,
  Connecteurs = 46,
  EmargementDigitalise = 47,
  Imports = 48,
  ChampsPerso = 49,
  ExportBPF = 50,
  Statistiques = 55,
  Exports = 63,
  ExportComptable = 64,
  PlanningRessources = 65,
  ReferentielCrm = 66,
  DroitTypeEntreprise = 67,
  EntitePrincipale = 68,
  AxesAnalytiques = 69,
  Charges = 70,
  ParametresAutomatisations = 71,
}
